import React from 'react';
import { Select, DatePicker } from 'antd';
import { spacing } from '../../theme';
import dayjs from 'dayjs';

function LastLoginFilterBar({ dateFilter, onDateFilterChange }) {
  const { operator = 'on', date } = dateFilter || {};

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md }}>
      <span style={{ fontWeight: 500 }}>Last Login:</span>
      <Select
        value={operator}
        onChange={(newOperator) => onDateFilterChange({ operator: newOperator, date })}
        style={{ minWidth: 95 }}
        options={[
          { label: 'On', value: 'on' },
          { label: 'After', value: 'after' },
          { label: 'Before', value: 'before' },
        ]}
      />
      <DatePicker
        value={date ? dayjs(date) : null}
        onChange={(newDate) => onDateFilterChange({ operator, date: newDate ? newDate.format('YYYY-MM-DD') : null })}
        style={{ width: 200 }}
      />
    </div>
  );
}

export default LastLoginFilterBar;
